import { common } from "./common";

export const darkTheme = {
  common: {
    ...common,
  },
  main: {
    primary: "#7D02FA",
  },
  background: {
    primary: "#0d1117",
    secondary: "#161b22",
  },
  text: {
    primary: "#000000",
    secondary: "#cccccc",
    disabled: "#acacac",
  },
  button: {
    primary: {
      normal: "#7D02FA",
      hover: "#6302C5",
      inactive: "#E3C7FF",
      text: "#000000",
      textHover: "#FFFFFF",
    },
    secondary: {
      normal: "#FFFFFF",
      hover: "#9630FD",
      inactive: "#E3C7FF",
      text: "#7D02FA",
      textHover: "#FFFFFF",
    },
    warning: "#CE1C1C",
    success: "27AE60",
  },
  border: {
    primary: "#7D02FA",
    secondary: "#B2B2B2",
    highlighted: "#1A1A1A",
  },
  themeButton: {
    color: "#FFFFFF",
  },
};
